import "./document.css"

import Header from "../../assets/components/01_header/header";
import Footer from "../../assets/components/02_footer/footer";

export default function TermsConditions() {
    return (
        <div>
            <Header />
            <div className="documentation">
                <h1 className="BlogTitle">TERMS &amp; CONDITIONS</h1>

                <p><strong>Last Updated:</strong> 21 February 2026</p>

                <p>
                These Terms &amp; Conditions ("Terms") govern the use of this website and the services provided by ("Agency", "we", "us", or "our"). By accessing this website or engaging our services, you ("Client", "you", or "your") agree to be bound by these Terms.
                </p>

                <h2>1. Acceptance of Terms</h2>
                <p>
                By accessing, browsing, or using this website and/or engaging the Agency for services, you acknowledge that you have read, understood, and agreed to be bound by these Terms, together with any applicable proposals, service agreements, statements of work, invoices, or written communications executed between you and the Agency. In the event of a conflict, the specific service agreement or invoice shall prevail.
                </p>

                <h2>2. Website Use</h2>
                <p>You agree not to:</p>
                <ul>
                <li>Misuse, disrupt, or interfere with the website or its functionality</li>
                <li>Attempt unauthorized access to systems, servers, or data</li>
                <li>Upload, transmit, or distribute unlawful, harmful, defamatory, infringing, or malicious content</li>
                <li>Use the website for any illegal or unauthorized purpose</li>
                </ul>
                <p>
                The Agency reserves the right to restrict or terminate access to the website for violations of this section.
                </p>

                <h2>3. Services</h2>
                <ul>
                <li>All information provided on this website is for general informational purposes only and does not constitute a binding offer.</li>
                <li>Services are provided only after a formal written agreement, proposal acceptance, or invoice confirmation.</li>
                <li>The scope, timelines, deliverables, and fees for services shall be governed exclusively by the applicable service agreement, proposal, or invoice.</li>
                </ul>

                <h2>3A. Additional Work, Scope Changes &amp; Rush Requests</h2>

                <p><strong>Additional Work Outside Scope</strong></p>
                <p>
                Any services, tasks, revisions, deliverables, or requests not expressly included in the agreed scope of work shall be considered additional work and shall be charged separately at rates determined by the Agency.
                </p>

                <p><strong>Approval &amp; Advance Payment</strong></p>
                <p>
                The Agency is not obligated to commence any additional work unless written approval and advance payment for such work is received, unless otherwise agreed in writing.
                </p>

                <p><strong>Rush / High-Priority Requests</strong></p>
                <p>
                Requests requiring expedited timelines, accelerated delivery, or priority execution beyond standard timelines (“Rush Work”) shall attract a separate rush fee, determined based on urgency, workload, and resource allocation.
                </p>

                <p><strong>Right to Accept or Decline Rush Work</strong></p>
                <p>
                The Agency reserves the absolute right to accept or decline Rush Work requests at its sole discretion based on availability, workload, or operational constraints. Refusal of Rush Work shall not constitute a breach of contract.
                </p>

                <p><strong>Third-Party Engagement for Urgent Needs</strong></p>
                <p>
                If Rush Work is declined, the Client may engage third-party service providers solely for such urgent requirements. This shall not affect the existing agreement with the Agency.
                </p>

                <p><strong>No Implied Obligation</strong></p>
                <p>
                Acceptance of any Rush Work does not create an obligation to accept future Rush Work requests.
                </p>

                <h2>4. Payments, Fees &amp; Billing</h2>

                <p><strong>Upfront Payments</strong></p>
                <p>All services are billed on an upfront payment basis unless otherwise agreed in writing.</p>

                <p><strong>Monthly Retainer Services</strong></p>
                <p>Retainer-based services operate on a renewable 28-day billing cycle, payable in advance.</p>

                <p><strong>Website Design &amp; Development</strong></p>
                <p>
                Website projects are payable upfront in full. EMI options are available only for projects exceeding INR 75,000, subject to written agreement and milestone-based terms.
                </p>

                <p><strong>Late Payments</strong></p>
                <p>Payments must be made within the first 7 days of the applicable 28-day cycle. Failure to do so may result in:</p>
                <ul>
                <li>Immediate suspension of services</li>
                <li>A late payment charge of 2% per week on outstanding amounts, capped at 24% per annum</li>
                </ul>
                <p>
                Suspension of services does not waive the Client’s obligation to pay all outstanding dues.
                </p>

                <h2>5. Contract Term, Renewal &amp; Termination</h2>
                <p>
                All service agreements operate on an automatically renewing 28-day contract cycle unless terminated in accordance with this section.
                </p>

                <p><strong>Client Termination &amp; Cancellation Charges</strong></p>
                <ul>
                <li>Notice more than 28 days before next cycle: No additional charges</li>
                <li>Notice between 28 and 14 days: 50% of the upcoming cycle fee payable</li>
                <li>Notice between 14 and 0 days: 100% of the upcoming cycle fee payable</li>
                </ul>
                <p>
                Termination is effective only after all outstanding dues are cleared.
                </p>

                <h2>6. Client Responsibilities</h2>
                <p>The Client agrees to:</p>
                <ul>
                <li>Provide timely feedback, approvals, content, and access required for service delivery</li>
                <li>Ensure all provided materials are accurate and lawful</li>
                <li>Acknowledge that delays caused by the Client automatically extend timelines without penalty to the Agency</li>
                </ul>
                <p>
                The Agency shall not be responsible for missed deadlines or performance issues arising from Client delays or non-cooperation.
                </p>

                <h2>7. Suspension of Services</h2>
                <p>The Agency may suspend services without liability if:</p>
                <ul>
                <li>Payments are overdue</li>
                <li>The Client breaches these Terms or any service agreement</li>
                <li>Required inputs, approvals, or access are not provided</li>
                </ul>
                <p>
                Suspension does not entitle the Client to refunds or fee reductions.
                </p>

                <h2>8. Refund Policy</h2>

                <p><strong>Agency Responsibility</strong></p>
                <p>
                If services are not delivered due solely to internal failure attributable to the Agency, a proportionate refund for the undelivered portion shall be issued.
                </p>

                <p><strong>Client Responsibility (No Refunds)</strong></p>
                <p>No refunds shall be issued where service delivery is impacted due to:</p>
                <ul>
                <li>Client delays, non-responsiveness, or scope changes</li>
                <li>Failure to provide approvals, assets, or access</li>
                <li>Platform-related issues beyond the Agency’s control</li>
                </ul>

                <p><strong>Scope Reduction</strong></p>
                <p>
                Any reduction in scope during an active cycle shall not reduce fees for that cycle. Revised pricing applies from the next cycle onward.
                </p>
                <p>
                All completed or in-progress work is non-refundable except as stated above.
                </p>

                <h2>9. Intellectual Property</h2>
                <p>
                All website content remains the exclusive property of the Agency. Client deliverables and usage rights shall be governed by the applicable service agreement. Unauthorized reproduction or distribution is prohibited.
                </p>

                <h2>10. Confidentiality</h2>
                <p>
                Both parties agree to keep confidential all non-public, proprietary, or sensitive information obtained during the course of the engagement, unless disclosure is required by law.
                </p>

                <h2>11. Third-Party Platforms &amp; Tools</h2>
                <p>The Agency shall not be liable for:</p>
                <ul>
                <li>Platform outages or downtime</li>
                <li>Algorithm changes or reach fluctuations</li>
                <li>Account suspensions or policy enforcement by third parties</li>
                <li>Changes in pricing or functionality of third-party tools</li>
                </ul>

                <h2>12. Disclaimer</h2>
                <p>
                The Agency does not guarantee specific results or outcomes. All services are provided on a best-effort basis consistent with industry standards.
                </p>

                <h2>13. Limitation of Liability</h2>
                <p>
                To the maximum extent permitted by law, the Agency shall not be liable for indirect, incidental, or consequential damages. Total liability shall not exceed the fees paid for the services giving rise to the claim.
                </p>

                <h2>14. Indemnification</h2>
                <p>
                The Client agrees to indemnify and hold harmless the Agency from claims, losses, or liabilities arising from client-provided content, violation of laws or third-party rights, or breach of these Terms or any agreement.
                </p>

                <h2>15. Force Majeure</h2>
                <p>
                The Agency shall not be liable for delays or failure to perform due to events beyond reasonable control, including acts of God, government actions, internet outages, platform failures, labor issues, or medical emergencies.
                </p>

                <h2>16. Assignment &amp; Subcontracting</h2>
                <p>
                The Agency may assign or subcontract all or part of the services without prior consent. The Client may not assign this agreement without written approval.
                </p>

                <h2>17. Entire Agreement</h2>
                <p>
                These Terms, together with any applicable service agreement, proposal, or invoice, constitute the entire agreement between the parties and supersede all prior communications or understandings.
                </p>

                <h2>18. Governing Law &amp; Jurisdiction</h2>
                <p>
                These Terms shall be governed by the laws of India. Courts located in Maharashtra shall have exclusive jurisdiction.
                </p>

                <h2>19. Changes to Terms</h2>
                <p>
                The Agency reserves the right to modify these Terms at any time. Continued use of services constitutes acceptance of revised Terms.
                </p>

                <h2>20. Contact Information</h2>
                <p>
                For questions regarding these Terms, contact:<br />
                <strong>Email:</strong> contact@adstrate.in
                </p>
            </div>
            <Footer />
        </div>
    );
}